// extracted by mini-css-extract-plugin
export var copyable = "_w-1";
export var explainable = "_w-0";
export var negative = "_w-2";
export var positive = "_w-3";